<div class="container">
    <div *ngIf="allMediaReady()" class="swiper mySwiper2"
        style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let media of mediaArray">
                <img *ngIf="media.type == 'image'" [src]="media.url" />
                <video *ngIf="media.type == 'video'" [src]="media.url" controls></video>
            </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
    <div thumbsSlider="" *ngIf="allMediaReady()" class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let media of mediaArray" #slideEl>
                <img *ngIf="media.type == 'image'" [src]="media.url" />
                <video *ngIf="media.type == 'video'" preload="metadata" playsinline [src]="media.url"
                    [controls]="false"></video>
            </div>
        </div>
    </div>
    <!--  -->
    <div *ngIf="allMediaReady() == false" class="false-swiper" style="background-color: black;">
        <div class="false-swipper-loader">

        </div>
    </div>
    <!---->
    <div *ngIf="allMediaReady() == false" thumbsSlider="" class="false-swiper2">
        <div class="false-preview">
            <div class="false-swipper-loader">

            </div>
        </div>
    </div>

</div>